// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import { emitApplyFilters, emitResetFilters } from '../datatables/filtersBus';

const AdminFilters = ({ modalState, onChange = (_) => void 0, value: filters = {}, reset = false, toggleModal }) => {
  const [amount, setAmount] = useState(filters.amount || '')
  const [amountMin, setAmountMin] = useState(filters.amount?.$gte || '')
  const [amountMax, setAmountMax] = useState(filters.amount?.$lte || '')

  const [createdMin, setCreatedMin] = useState(filters.created?.$gte || '')
  const [createdMax, setCreatedMax] = useState(filters.created?.$lte || '')
  const [updatedMin, setUpdatedMin] = useState(filters.updated?.$gte || '')
  const [updatedMax, setUpdatedMax] = useState(filters.updated?.$lte || '')

  useEffect(resetFilters, [reset])

  useEffect(() => setAmount(''), [amountMin, amountMax])
  useEffect(() => {
    setAmountMin('')
    setAmountMax('')
  }, [amount])

  useEffect(() => {
    let nextFilters = {
      ... (amount !== '' ? { amount: +amount } : {}),
      ... (amountMin !== '' || amountMax !== '' ? {
        amount: {
          ... (amountMin !== '' ? { $gte: +amountMin } : {}),
          ... (amountMax !== '' ? { $lte: +amountMax } : {})
        }
      } : {}),
      ... (createdMin !== '' || createdMax !== '' ? {
        createdAt: {
          ... (createdMin !== '' ? { $gte: createdMin } : {}),
          ... (createdMax !== '' ? { $lte: createdMax } : {})
        }
      } : {}),
      ... (updatedMin !== '' || updatedMax !== '' ? {
        updateAt: {
          ... (updatedMin !== '' ? { $gte: updatedMin } : {}),
          ... (updatedMax !== '' ? { $lte: updatedMax } : {})
        }
      } : {}),
    }

    onChange(nextFilters)
  }, [amount, amountMin, amountMax, createdMin, createdMax, updatedMin, updatedMax])

  function resetFilters() {
    setAmount('')
    setAmountMin('')
    setAmountMax('')
    setCreatedMin('')
    setCreatedMax('')
    setUpdatedMin('')
    setUpdatedMax('')
    emitResetFilters()
  }

  const closeModal = () => {
    toggleModal(false, 'admminFilters');
  };

  const buildFilters = () => {
    return {
      ... (amount !== '' ? { amount: +amount } : {}),
      ... (amountMin !== '' || amountMax !== '' ? {
        amount: {
          ... (amountMin !== '' ? { $gte: +amountMin } : {}),
          ... (amountMax !== '' ? { $lte: +amountMax } : {})
        }
      } : {}),
      ... (createdMin !== '' || createdMax !== '' ? {
        createdAt: {
          ... (createdMin !== '' ? { $gte: createdMin } : {}),
          ... (createdMax !== '' ? { $lte: createdMax } : {})
        }
      } : {}),
      ... (updatedMin !== '' || updatedMax !== '' ? {
        updateAt: {
          ... (updatedMin !== '' ? { $gte: updatedMin } : {}),
          ... (updatedMax !== '' ? { $lte: updatedMax } : {})
        }
      } : {}),
    }
  }

  const applyAndClose = () => {
    const next = buildFilters()
    emitApplyFilters(next)
    closeModal()
  }

  return (
    <>
      <div className="dashboard-modal dashboard-modal--open dashboard-modal--filters">
        <div className="dashboard-modal-panel">
          <div className="dashboard-modal-header">
            <div className="dashboard-modal-title">Filters</div>
            <button className="dashboard-modal-close" aria-label="close" onClick={closeModal}></button>

          </div>
          <div className="dashboard-modal-body">
            <div className="field_row">
              <div className="field_name">
                <label htmlFor="existingCard">Amount</label>
              </div>
              <div className="field_block">
                <input type="text" name="amount" placeholder="Amount" value={amount} onChange={e => setAmount(e.target.value)} />
              </div>
            </div>
            <div className="field_row">
              <div className="field_name"></div>
              <div className="field_block">
                <input
                  id="per2_min"
                  name="per2_min"
                  type="text"
                  maxLength="10"
                  placeholder="$0.00"
                  value={amountMin}
                  onChange={e => setAmountMin(e.target.value)}
                />
                <span className="step_btns">
                  <span className="icon_stepup"></span>
                  <span className="icon_stepdown"></span>
                </span>
              </div>
              <div className="field_block">
                <input
                  id="per2_max"
                  name="per2_max"
                  type="text"
                  maxLength="10"
                  placeholder="$0.00"
                  value={amountMax}
                  onChange={e => setAmountMax(e.target.value)}
                />
                <span className="step_btns">
                  <span className="icon_stepup"></span>
                  <span className="icon_stepdown"></span>
                </span>
              </div>
            </div>
            <div className="separate"></div>

            <div className="field_row">
              <div className="field_name">
                <label htmlFor="createdDate">Created at</label>
              </div>
              <div className="field_block">
                <input
                  type="date"
                  name="created_start"
                  className="card_date"
                  id="createdDateStart"
                  maxLength="50"
                  placeholder="Title"
                  value={createdMin}
                  onChange={e => setCreatedMin(e.target.value)}
                />
              </div>
              <div className="field_block">
                <input
                  type="date"
                  name="created_end"
                  className="card_date"
                  id="createdDateEnd"
                  maxLength="50"
                  placeholder="Title"
                  value={createdMax}
                  onChange={e => setCreatedMax(e.target.value)}
                />
              </div>
            </div>
            <div className="field_row">
              <div className="field_name">
                <label htmlFor="updatedDate">Updated at</label>
              </div>
              <div className="field_block">
                <input
                  type="date"
                  name="updated_start"
                  className="card_date"
                  id="updatedDateStart"
                  maxLength="50"
                  placeholder="Title"
                  value={updatedMin}
                  onChange={e => setUpdatedMin(e.target.value)}
                />
              </div>
              <div className="field_block">
                <input
                  type="date"
                  name="updated_end"
                  className="card_date"
                  id="updatedDateEnd"
                  maxLength="50"
                  placeholder="Title"
                  value={updatedMax}
                  onChange={e => setUpdatedMax(e.target.value)}
                />
              </div>
            </div>
            <div className="dashboard-modal-footer">
              <button className="dashboard-btn dashboard-btn--secondary" aria-label="cancel" onClick={resetFilters}>Reset</button>
              <button className="dashboard-btn dashboard-btn--primary" aria-label="save" onClick={applyAndClose}>Apply</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.admminFilters,
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminFilters);

